// Browser-bonprint ZONDER QZ Tray (Optie B).
// De bon wordt als 80mm-HTML in een verborgen iframe gerenderd en via window.print() naar de
// STANDAARDPRINTER van Windows gestuurd (een grafische driver zoals "GP-80 Series" rastert dit
// netjes). Met Chrome in kiosk-print-modus (--kiosk-printing) print dit stil zonder dialoog;
// anders verschijnt de normale printdialoog. De kassalade opent via de driver-instelling van de
// printer (ESC/POS-ladepuls kan niet via de browser). Printfouten laten de verkoop nooit crashen.

const eur = (c) => '\u20AC\u00A0' + (Number(c || 0) / 100).toFixed(2).replace('.', ',');
const esc = (s) => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
const when = (iso) => { try { return new Date(iso).toLocaleString('nl-BE'); } catch { return iso || ''; } };
const vatLabel = (r) => r.treatment === 'TOBACCO_SPECIAL' ? 'Tabak - bijz.' : r.treatment === 'EXEMPT_LOTTERY' ? 'Vrijgesteld' : 'BTW ' + r.vat + '%';

function vatGroups(lines) {
  const map = {};
  (lines || []).forEach((l) => {
    const key = (l.treatment || 'STANDARD') + ':' + (l.vat ?? 0);
    const g = map[key] || { vat: l.vat ?? 0, treatment: l.treatment || 'STANDARD', netCents: 0, vatCents: 0, grossCents: 0 };
    g.netCents += l.netCents || 0; g.vatCents += l.vatCents || 0; g.grossCents += l.grossCents || 0;
    map[key] = g;
  });
  return Object.values(map).sort((a, b) => (a.vat - b.vat));
}

const rowHtml = (l, r) => `<div class="row"><span>${l}</span><span>${r}</span></div>`;

function receiptInner(item) {
  const isRefund = item.kind === 'REFUND';
  let h = '';
  h += `<div class="c name">${esc((item.company?.name || 'Singh Express Shop').toUpperCase())}</div>`;
  if (item.company?.address) h += `<div class="c sm">${esc(item.company.address)}</div>`;
  if (item.company?.enterpriseNumber) h += `<div class="c sm">Ondernemingsnr: ${esc(item.company.enterpriseNumber)}</div>`;
  h += `<div class="hr"></div>`;
  h += `<div class="row b"><span>${isRefund ? 'RETOURBON' : 'KASSABON'}</span><span>Nr. ${String(item.number || 0).padStart(4, '0')}</span></div>`;
  h += `<div class="sm">${esc(when(item.occurredAt))}${item.actorName ? ' \u00B7 ' + esc(item.actorName) : ''}</div>`;
  if (item.originalReceiptId) h += `<div class="sm">Retour op ${esc(item.originalReceiptId)}${item.reason ? '<br>Reden: ' + esc(item.reason) : ''}${item.approvedByName ? '<br>Goedgekeurd door ' + esc(item.approvedByName) : ''}</div>`;
  h += `<div class="hr"></div>`;
  (item.lines || []).forEach((l) => {
    h += rowHtml(esc(l.quantity + '\u00D7 ' + (l.name || '')), '<b>' + eur(l.grossCents) + '</b>');
    if ((l.quantity || 1) > 1 && l.unitPriceCents != null) h += `<div class="sm ind">(${l.quantity} \u00D7 ${eur(l.unitPriceCents)})</div>`;
    if (l.discountCents) h += `<div class="sm ind">korting ${eur(l.discountCents)}</div>`;
  });
  h += `<div class="hr"></div>`;
  h += rowHtml('Subtotaal', eur(item.unroundedTotalCents));
  if (item.roundingCents) h += rowHtml('Afronding', eur(item.roundingCents));
  h += `<div class="row tot"><span>TOTAAL</span><span>${eur(item.totalCents)}</span></div>`;
  const groups = vatGroups(item.lines);
  if (groups.length) {
    h += `<div class="hr"></div><div class="sm b">BTW-overzicht</div>`;
    groups.forEach((g) => { h += rowHtml('<span class="sm">' + vatLabel(g) + '</span>', '<span class="sm">excl ' + eur(g.netCents) + ' \u00B7 btw ' + eur(g.vatCents) + '</span>'); });
  }
  h += `<div class="hr"></div>`;
  h += `<div class="sm">Betaald: ${item.paymentMethod === 'CASH' ? 'Contant' : 'Bancontact / Kaart'}</div>`;
  if (item.receivedCents != null) h += rowHtml('Ontvangen', eur(item.receivedCents)) + rowHtml('Teruggegeven', eur(item.changeCents));
  if (item.hash) h += `<div class="hr"></div><div class="sm hash">Controlehash: ${esc(item.hash)}</div>`;
  h += `<div class="c foot">Bedankt voor uw bezoek!</div>`;
  return h;
}

function zInner(z) {
  const rateName = (r) => r.treatment === 'TOBACCO_SPECIAL' ? 'Tabak - bijzonder' : r.treatment === 'EXEMPT_LOTTERY' ? 'Loterij - vrijgesteld' : 'BTW ' + r.vat + '%';
  let h = '';
  h += `<div class="c name">${esc((z.company?.name || 'Singh Express Shop').toUpperCase())}</div>`;
  h += `<div class="c sm">${esc(z.company?.address || '')}${z.company?.enterpriseNumber ? '<br>Ondernemingsnr: ' + esc(z.company.enterpriseNumber) : ''}</div>`;
  h += `<div class="hr"></div><div class="row b"><span>Z-TICKET</span><span>Nr. ${esc(z.number)}</span></div>`;
  h += `<div class="sm">Kassadag: ${esc(z.businessDate)}<br>Afgesloten: ${esc(when(z.closedAt))}${z.actorName ? '<br>' + esc(z.actorName) : ''}</div>`;
  h += `<div class="hr"></div><div class="c b">VERKOOP PER BTW-TARIEF</div>`;
  (z.taxRows || []).forEach((r) => {
    h += `<div class="b" style="margin-top:4px">${rateName(r)}</div>`;
    h += rowHtml('Omzet excl.', eur(r.netCents)) + rowHtml('BTW', eur(r.vatCents)) + rowHtml('<b>Omzet incl.</b>', '<b>' + eur(r.grossCents) + '</b>');
  });
  h += `<div class="hr"></div><div class="row b"><span>TOTAAL INCL. BTW</span><span>${eur(z.totalInclCents)}</span></div>`;
  h += rowHtml('Afrondingsverschil', eur(z.roundingCents)) + rowHtml('Totaal afgerond', eur(z.totalPaidCents));
  h += `<div class="hr"></div>` + rowHtml('Aantal transacties', z.transactionCount) + rowHtml('Retours', z.returnCount);
  if (Array.isArray(z.byShop) && z.byShop.some((s) => s.transactionCount || s.returnCount || s.totalInclCents)) {
    h += `<div class="hr"></div><div class="c b">OMZET PER WINKEL</div>`;
    z.byShop.forEach((s) => { h += `<div class="b" style="margin-top:4px">${esc(s.displayName || s.name)}</div>` + rowHtml('Omzet incl.', eur(s.totalInclCents)) + `<div class="sm">${s.transactionCount} verkopen \u00B7 ${s.returnCount} retours</div>`; });
  }
  h += `<div class="hr"></div><div class="row b"><span>GRAND TOTAL</span><span>${eur(z.grandTotalCents)}</span></div>`;
  h += `<div class="sm">(cumulatief sinds ingebruikname kassa)</div>`;
  h += `<div class="hr"></div><div class="c sm">Bewaar dit Z-ticket conform de wettelijke bewaartermijn.</div>`;
  if (z.hash) h += `<div class="sm hash">Controlehash: ${esc(z.hash)}</div>`;
  return h;
}

function wrap(inner, cfg) {
  const paper = Number(cfg?.paperWidth) === 58 ? 58 : 80;
  const bodyW = paper === 58 ? 54 : 74; // printbare breedte in mm
  return `<!doctype html><html><head><meta charset="utf-8"><style>
    @page { size: ${paper}mm auto; margin: 0; }
    * { margin:0; padding:0; box-sizing:border-box; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
    html,body { width:${bodyW}mm; background:#fff; }
    body { font-family:'Courier New',monospace; font-size:12px; line-height:1.4; color:#000; padding:2mm 1mm 4mm; }
    .c{text-align:center}
    .name{font-size:17px;font-weight:800;letter-spacing:.5px;margin-bottom:2px}
    .b{font-weight:800}
    .sm{font-size:10px}
    .ind{padding-left:8px}
    .hash{word-break:break-all;font-size:9px}
    .row{display:flex;justify-content:space-between;gap:8px}
    .row span:last-child{white-space:nowrap}
    .hr{border-top:1px dashed #000;margin:5px 0}
    .tot{font-size:16px;font-weight:800;margin-top:2px}
    .foot{margin-top:10px;font-size:12px}
  </style></head><body>${inner}</body></html>`;
}

function printHtml(html) {
  return new Promise((resolve) => {
    const ifr = document.createElement('iframe');
    ifr.setAttribute('aria-hidden', 'true');
    ifr.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;';
    document.body.appendChild(ifr);
    const cleanup = () => { try { document.body.removeChild(ifr); } catch (_) {} resolve(); };
    try {
      const d = ifr.contentWindow.document;
      d.open(); d.write(html); d.close();
      const fire = () => {
        try { ifr.contentWindow.print(); } catch (e) { console.error('[bonprinter] browser print fout', e); }
        setTimeout(cleanup, 400);
      };
      requestAnimationFrame(() => requestAnimationFrame(fire));
    } catch (e) { console.error('[bonprinter] iframe fout', e); cleanup(); }
  });
}

export async function htmlPrintReceipt(item, cfg) { await printHtml(wrap(receiptInner(item), cfg)); }
export async function htmlPrintZ(z, cfg) { await printHtml(wrap(zInner(z), cfg)); }
export async function htmlOpenDrawer(cfg) { await printHtml(wrap('<div style="height:1px"></div>', cfg)); }
export async function htmlTestPrint(cfg) {
  const sample = {
    kind: 'SALE', number: 123, occurredAt: new Date().toISOString(), actorName: 'Testkassier',
    company: { name: 'Singh Express Shop', address: 'Teststraat 1, 3800 Sint-Truiden', enterpriseNumber: 'BE0788952072' },
    lines: [
      { quantity: 1, name: 'Cola 33cl', grossCents: 180, unitPriceCents: 180, vat: 21, treatment: 'STANDARD', netCents: 149, vatCents: 31 },
      { quantity: 2, name: 'Brood', grossCents: 600, unitPriceCents: 300, vat: 6, treatment: 'STANDARD', netCents: 566, vatCents: 34 },
    ],
    unroundedTotalCents: 780, roundingCents: 0, totalCents: 780,
    paymentMethod: 'CASH', receivedCents: 1000, changeCents: 220, hash: 'TEST-0000-0000',
  };
  await printHtml(wrap(receiptInner(sample), cfg));
}
